module.exports = __webpack_public_path__ + "img/urbanismovivo.3e9344d6.png";